import apiClient from './apiClient';

export const ticketsService = {
  preview: (payload) =>
    apiClient.post('/tickets/preview', payload).then((res) => res.data),
  purchase: (payload) =>
    apiClient.post('/tickets/purchase', payload).then((res) => res.data),
};
